export default __webpack_public_path__ + "static/media/pool.6ef5c270.jpg";